// extracted by mini-css-extract-plugin
module.exports = {"countryPage":"CountryDetails_countryPage_qBRpe","backButton":"CountryDetails_backButton_11Wfs","countryPageLoading":"CountryDetails_countryPageLoading_2-2Lx"};